import { If, location } from 'cdui-js';
import { lastProcess, nextProcess, pState } from '../store';
import { PreparePage } from './PreparePage';
import { Time } from './Time';
import { VerificationPoint } from './VerificationPoint';
import { ContactInfos } from './ContactInfos';
import { Successful } from './Successful';

const maps = {
  2: () => <VerificationPoint />,
  3: () => <Time />,
  4: () => <ContactInfos />,
  5: () => <Successful />,
};

export const OffLine = () => {
  const OffLineViews = () => {
    return maps[pState.current]?.();
  };

  return (
    <div style={{ height: '100%' }}>
      <If when={pState.current === 1}>
        <PreparePage />
      </If>

      <If when={pState.current !== 1}>
        <div>{OffLineViews()}</div>
      </If>
      {/* style={{ height: 'calc(100% - 80px)', 'overflow-y': 'auto' }} */}

      {/* <If when={pState.current >= 2}>
        <div class="flex padding-x-L align-center" style={{ gap: '10px', height: '80px' }}>
          <If when={pState.current !== 5}>
            <button class="default-btn btn-rounded" style={{ height: '50px', flex: 1 }} onclick={() => lastProcess()}>
              上一步
            </button>

            <button class="primary-btn btn-rounded" style={{ flex: 2 }} onclick={() => nextProcess()}>
              {pState.current === 4 ? '提交预约' : '下一步'}
            </button>
          </If>
          <If when={pState.current === 5}>
            <button class="primary-btn btn-rounded" style={{ flex: 2 }} onclick={() => location.routeTo('/account')}>
              完成
            </button>
          </If>
        </div>
      </If> */}
    </div>
  );
};
